import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Button, Alert } from 'react-bootstrap';
import { ArrowLeft } from '@styled-icons/fa-solid';
import { postTaricHistory } from '../../api/taric';
import DataTable from '../DataTable';
import isoDateConverter from '../isoDateConverter';

const TaricHistory = () => {
  const { id: commodityCode } = useParams();
  const navigate = useNavigate();
  const [historyData, setHistoryData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showToast, setShowToast] = useState(false);

  useEffect(() => {
    const loadHistoryData = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await postTaricHistory(commodityCode);
        setHistoryData(response || []);
      } catch (err) {
        console.error('Failed to load history data:', err);
        setError(`Failed to load history data: ${err.message}`);
        setShowToast({
          toastTitle: 'History Error',
          toastBody: `Failed to load history data: ${err.message}`,
        });
      } finally {
        setLoading(false);
      }
    };

    loadHistoryData();
  }, [commodityCode]);

  const toastContent = () => {
    return (
      <Alert style={{ maxWidth: '35rem', backgroundColor: '#E4E3ED' }} show={showToast}>
        <button className="btn-close position-absolute top-0 end-0 p-3" onClick={() => setShowToast(false)} />
        <h1 className="floating-box-header-newload align-items-center" style={{ margin: '0px 30px', padding: 0 }}>
          <span>{showToast?.toastTitle}</span>
        </h1>
        <p style={{ fontSize: '100%', fontWeight: 500 }} className="text-danger">
          {showToast?.toastBody}
        </p>
      </Alert>
    );
  };

  if (loading) {
    return (
      <div className="full-width-container">
        <section className="floating-box position-relative" style={{ maxWidth: '1200px' }}>
          <h1 className="floating-box-header-newload">
            <span>TARIC History</span>
          </h1>
          <div style={{ padding: '16px 32px', marginBottom: '0', minHeight: '200px' }}>
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
              <Button
                variant="link"
                onClick={() => navigate(`/taric/${commodityCode}`)}
                className="back-button"
                style={{ padding: 0, margin: 0, color: '#0d6efd', textDecoration: 'underline' }}
              >
                <ArrowLeft size={16} />
                Back to Taric Details
              </Button>
            </div>
            <div style={{ textAlign: 'center', marginTop: '50px' }}>
              <p>Loading history data...</p>
            </div>
          </div>
        </section>
      </div>
    );
  }

  if (error) {
    return (
      <div className="full-width-container">
        <section className="floating-box position-relative" style={{ maxWidth: '1200px' }}>
          <h1 className="floating-box-header-newload">
            <span>TARIC History</span>
          </h1>
          <div style={{ padding: '16px 32px', marginBottom: '0', minHeight: '200px' }}>
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
              <Button
                variant="link"
                onClick={() => navigate(`/taric/${commodityCode}`)}
                className="back-button"
                style={{ padding: 0, margin: 0, color: '#0d6efd', textDecoration: 'underline' }}
              >
                <ArrowLeft size={16} />
                Back to Taric Details
              </Button>
            </div>
            <div style={{ textAlign: 'center', marginTop: '50px', color: 'red' }}>
              <p>{error}</p>
            </div>
          </div>
        </section>
      </div>
    );
  }

  return (
    <div className="full-width-container">
      {toastContent()}
      <section className="floating-box position-relative" style={{ maxWidth: '1200px' }}>
        <h1 className="floating-box-header-newload">
          <span>TARIC History</span>
        </h1>
        <div style={{ padding: '16px 32px', marginBottom: '0', minHeight: '200px' }}>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
            <Button
              variant="link"
              onClick={() => navigate(`/taric/${commodityCode}`)}
              className="back-button"
              style={{ padding: 0, margin: 0, color: '#0d6efd', textDecoration: 'underline' }}
            >
              <ArrowLeft size={16} />
              Back to Taric Details
            </Button>
          </div>
          <div style={{ overflowX: 'auto', marginTop: 24 }}>
            <DataTable data={historyData} className="table-bordered" style={{ background: '#fff' }}>
              <DataTable.Headers />
              <DataTable.Row />
              <DataTable.Column colKey="type" header="TYPE" style={{ width: '200px' }}>
                {(item) => <input type="text" className="form-control" value={item.type || ''} readOnly />}
              </DataTable.Column>
              <DataTable.Column colKey="History" header="History" style={{ width: '300px' }}>
                {(item) => <input type="text" className="form-control" value={item.History || ''} readOnly />}
              </DataTable.Column>
              <DataTable.Column colKey="Who" header="Who" style={{ width: '150px' }}>
                {(item) => <input type="text" className="form-control" value={item.Who || ''} readOnly />}
              </DataTable.Column>
              <DataTable.Column colKey="When" header="When" style={{ width: '200px' }}>
                {(item) => <input type="text" className="form-control" value={isoDateConverter(item.When)} readOnly />}
              </DataTable.Column>
            </DataTable>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TaricHistory;
